import Swal from 'sweetalert2';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class ToastService {

    constructor(
        private translateService: TranslateService,
    ) {
    }

    success(messageKey: string) {
        this.toast(messageKey, 'success');
    }

    warning(messageKey: string) {
        this.toast(messageKey, 'warning');
    }

    error(messageKey: string) {
        this.toast(messageKey, 'error');
    }

    private toast(messageKey: string|null, type: 'success' | 'error' | 'warning' | 'info' | any) {
        let text = messageKey;

        if (!text && type === 'error') {
            text = 'error';
        } else if (!text) {
            return;
        }

        const looksLikeKey = /^[a-z0-9_.-]+$/i.test(text);
        const translate = looksLikeKey ? this.translateService.instant(text) : text;
        const display = translate || text;
        const timer = looksLikeKey ? 3500 : Math.min(15000, Math.max(6000, display.length * 40));

        if (!['success', 'error', 'warning', 'info'].includes(type)) {
            type = 'info';
        }

        Swal.fire({
            text: display,
            icon: type,
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
            }
        });
    }

}
